import { render } from "./GridDrepturiRoluri.vue?vue&type=template&id=02238a55&ts=true"
import script from "./GridDrepturiRoluri.vue?vue&type=script&lang=ts"
export * from "./GridDrepturiRoluri.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__